import {
  CREATE_INVOICE_STEP_URL,
  GET_ALL_PROJECT_SERVICES,
  LIST_INVOICE_STEP_URL,
  LIST_LEAD_SUB_STATUSES_URL,
  VIEW_FORM_STATUS,
  get_headers
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins.js';
import axios from 'axios';

export default {
  name: 'InvoiceStepsConfiguration',
  mixins: [alert_mixin, formatting_mixins],

  data: () => ({
    headers: get_headers(),
    project_id: sessionStorage.getItem('project_id'),
    entity_type_id: sessionStorage.getItem("entity_type_id") || "",
    saveButtonText: 'Save Configuration',
    steps: [
    ],
    services: [],
    trigger_statuses: [],
    target_phases: [
      { phase: 'Lead' },
      { phase: 'Application' },
      { phase: 'Client' }
    ],
    trigger_lead_statuses: ['test lead'],
    trigger_application_status: ['test Application'],
  }),
  methods: {
    toggle_condition(step, conditionIndex) {
      if (
        Array.isArray(step.conditions) &&
        Number.isInteger(conditionIndex)
      ) {
        const condition = step.conditions.at(conditionIndex);
        if (condition) {
          condition.active = !condition.active;
          this.mark_as_unsaved(step);
          this.auto_save_step(step);
        }
      }
    },

    editStep(stepId) {
      alert(`Editing step ${stepId}`);
    },

    delete_step(stepId) {
      if (confirm(`Are you sure you want to delete this step?`)) {
        this.steps = this.steps.filter(step => step.id !== stepId);
        alert(`Step deleted`);
      }
    },

    add_new_step() {
      const newStep = {
        id: Date.now(),
        title: 'Invoice Step',
        name: '',
        priority: '',
        template: '',
        delay: 0,
        isActive: true,
        saveStatus: 'none',
        hasUnsavedChanges: false,
        target_phase: '',
        trigger: '',
        type: 'once_off',
        frequency: 'once_off',
        min_payment_type: 'percentage',
        min_payment_value: 0,
        conditions: [],
        items: []
      };
      this.steps.push(newStep);
    },

    add_invoice_item(step) {
      const newItem = {
        description: '',
        type: '',
        quantity: 1,
        unitPrice: 0,
        source: 'manual'
      };
      step.items.push(newItem);
      this.mark_as_unsaved(step);
    },

    remove_invoice_item(step, itemIndex) {
      step.items.splice(itemIndex, 1);
      this.mark_as_unsaved(step);
    },

    on_target_phase_change(step) {
      this.mark_as_unsaved(step);
      step.trigger_status = ''; // clear previous status when phase changes
    },

    get_trigger_statuses(step) {
      if (!step || !step.target_phase) return [];

      let statuses = [];

      if (step.target_phase === 'Lead') {
        statuses = this.trigger_lead_statuses;
      } else if (step.target_phase === 'Application') {
        statuses = this.trigger_application_statuses;
      }

      return statuses.map(status => {
        const formatted = this.format_question_type(status.status_name || status.name);
        return {
          ...status,
          formatted_status: formatted,
        };
      });
    },

    on_trigger_status_change(event, step) {
      step.trigger_status = event.target.value;
      this.mark_as_unsaved(step);
    },

    async get_lead_statuses() {
      const params = {
        filter: {}
      }
      const response = await axios.get(
        LIST_LEAD_SUB_STATUSES_URL, {
        headers: this.headers,
        query_params: params
      });

      this.trigger_lead_statuses = response.data.data.map((statuses) => ({
        id: statuses.id,
        status_name: statuses.enquiry_status + " " + statuses.enquiry_sub_status,
      }))
    },



    mark_as_unsaved(step) {
      step.hasUnsavedChanges = true;
      step.saveStatus = 'unsaved';

      // Auto-save after 2 seconds
      clearTimeout(step.autoSaveTimeout);
      step.autoSaveTimeout = setTimeout(() => {
        this.auto_save_step(step);
      }, 2000);
    },

    auto_save_step(step) {
      step.saveStatus = 'saving';

      setTimeout(() => {
        step.saveStatus = 'saved';
        step.hasUnsavedChanges = false;
      }, 1000);
    },

    save_configuratuion() {
      this.saveButtonText = 'Saving...';

      // Reset all unsaved changes
      this.steps.forEach(step => {
        step.hasUnsavedChanges = false;
        step.saveStatus = 'saved';
      });

      setTimeout(() => {
        this.saveButtonText = 'Saved!';

        setTimeout(() => {
          this.saveButtonText = 'Save Configuration';
        }, 2000);
      }, 1500);
    },

    calculate_step_total(step) {
      return step.items.reduce((total, item) => {
        return total + (item.quantity * item.unitPrice);
      }, 0);
    },

    format_currency(amount) {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    },

    update_selected_item(step, item) {
      const selected = this.services.find(i => i.id === item.selectedItemId);
      if (selected) {
        item.description = selected.name;
        item.unitPrice = parseFloat(selected.price);
        this.mark_as_unsaved(step);
      }
    },
    async get_services() {
      const project_id = this.project_id;

      try {
        const response = await axios.get(GET_ALL_PROJECT_SERVICES, {
          headers: this.headers,
          params: { project_id }
        });

        const response_data = response.data;

        if (response_data.status === 'success') {

          this.services = response_data.data;
        } else {
          this.show_error('Error during the form submit');
          this.close_modal('create_trust_type');
        }
      }
      catch (error) {
        if (error.response && error.response.data) {
          this.show_error(error.response.data.message);
        }
      }

    },

    async get_statuses() {
      const payload = { project_id: this.project_id };

      try {
        let response = await axios.get(VIEW_FORM_STATUS, {
          headers: this.headers,
          params: payload
        });

        this.trigger_application_statuses = response.data.data.map((statuses) => ({
          id: statuses.id,
          status_name: statuses.status,
        }))

      } catch (error) {
        this.show_error(`Error fetching status: ${error.response?.data?.message}`);
      }
    },

    generate_payload() {
      const entity_type_id = this.entity_type_id;

      const invoice_steps = this.steps.map((step, index) => {
        const mappedStep = {
          name: step.name || step.title,
          step_order: index + 1,
          is_recurring: false,
          is_automatic: step.isActive,
          frequency: step.frequency || '',
          target_phase: step.target_phase || '',
          condition: {}
        };

        // Build condition dynamically:
        if (step.target_phase === 'Lead') {
          mappedStep.condition = {
            field: 'sub_status__code',
            status: step.trigger_status || ''
          };
        } else if (step.target_phase === 'Application') {
          mappedStep.condition = {
            field: 'form_status',
            status: step.trigger_status || ''
          };
        } else {
          mappedStep.condition = {};
        }

        if (step.items && step.items.length > 0) {
          mappedStep.items = step.items.map((item, itemIndex) => ({
            service: item.selectedItemId,
            quantity: item.quantity,
            order: itemIndex + 1,
          }));
        }

        return mappedStep;
      });

      const payload = {
        entity_type_id: entity_type_id,
        invoice_steps: invoice_steps
      };
      return payload;
    },

    save_configuration() {
      const payload = this.generate_payload();

      axios.post(CREATE_INVOICE_STEP_URL, payload, { headers: this.headers })
        .then(response => {
          if (response.data.status === 'success') {
            this.show_success('Configuration saved successfully!');
            this.steps.forEach(step => {
              step.hasUnsavedChanges = false;
              step.saveStatus = 'saved';
            });
            this.view_create_invoice_steps();
          } else {
            this.show_error('Error saving configuration: ' + response.data.message);
          }
        })
        .catch(error => {
          this.show_error(`Error fetching main statuses: ${error.response?.data?.message}`);
        });
    },

    view_create_invoice_steps() {

      const params = { entity_type_id: this.entity_type_id };

      axios.get(LIST_INVOICE_STEP_URL, {
        headers: this.headers,
        params: params
      })
        .then(response => {
          if (response.data.status === 'success') {
            const steps_from_api = response.data.data;

            this.steps = steps_from_api.map(step => {
              return {
                id: Date.now() + Math.random(), // unique id
                name: step.name,
                title: step.name,
                step_order: step.step_order,
                isActive: step.is_automatic,
                is_recurring: step.is_recurring,
                saveStatus: 'saved',
                hasUnsavedChanges: false,
                type: step.type || 'once_off',
                frequency: step.frequency || (step.type === 'recurring' ? 'weekly' : 'once_off'),
                min_payment_type: step.min_payment_type || 'percentage',
                min_payment_value: step.min_payment_value || 0,
                target_phase: step.target_phase || '',
                trigger_status: step.condition?.condition?.status || null,
                conditions: [],
                items: step.items.map(item => ({
                  selectedItemId: item.service.id,
                  description: item.service.name,
                  quantity: item.quantity,
                  order: item.order,
                  unitPrice: parseFloat(item.service.price) || 0,
                }))
              };
            });
          } else {
            this.show_error('Error saving configuration: ' + response.data.message);
          }
        })
        .catch(error => {
          this.show_error(`Error fetching invoice steps: ${error.response?.data?.message}`);
        });
    },

  },



  mounted() {
    this.get_services();
    this.get_statuses();
    this.get_lead_statuses();
    this.view_create_invoice_steps();

    // Animate cards on mount
    this.$nextTick(() => {
      const cards = this.$el.querySelectorAll('.step-card');
      cards.forEach((card, index) => {
        card.style.opacity = '0';
        card.style.transform = 'translateY(20px)';
        setTimeout(() => {
          card.style.transition = 'all 0.6s ease';
          card.style.opacity = '1';
          card.style.transform = 'translateY(0)';
        }, index * 200);
      });
    });
  }
}
